import React, {Fragment, useEffect, useState, useRef, useContext} from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import HeaderSection from './HeaderSection';
import FooterSection from './FooterSection';
import { InstallationsContext, GenericContext, MqttContext } from './App';
import PermanentAlertsBar from "./PermanentAlertsBar";
import {
  dateToTimestamp, timestampToDate, timestampToLocalDateString,
  timestampToLocalTimeString
} from "../utilities";
import CaseTableRow from "./CaseTableRow";
import {SITE_LINKS} from "../Contants";
import dateSub from "date-fns/sub";
import { it, enUS, enGB, de, fr } from 'date-fns/esm/locale';
import DatePicker, {registerLocale, setDefaultLocale} from 'react-datepicker';
import useDebounceCallback from "../custom-hooks/use-debounce-callback";
import Select from 'react-select';
import InstallationsFilter from "./InstallationsFilter";
import {
  CASE_DESCRIPTION_TYPE_ALARM,
  CASE_DESCRIPTION_TYPE_PROG_CALL,
  CASE_DESCRIPTION_TYPE_TECH,
  CASE_DESCRIPTION_TYPE_WARNING,
} from "../api/wimhome-api";
import {Puff} from "react-loader-spinner";

//Used by react-datepicker
registerLocale('it', it);
registerLocale('de', de);
registerLocale('fr', fr);
registerLocale('en-US', enUS);
registerLocale('en-GB', enGB);
registerLocale('en', enUS);
setDefaultLocale('it');

export default withRouter(function ReviewsPage(props) {
  const MAX_ENTRIES = 1000;

  const {
    history,
    currRoute,
  } = props;
  const {t, i18n} = useTranslation();

  const {
    selectedInst,
    installations,
    loadInstallationsCases,
    loadAllInstallationData,
    handleSelectInstallation,
  } = useContext(InstallationsContext);
  const { errors, userType } = useContext(GenericContext);
  // instSerial -> Promise (in volo) oppure Map risolta: unica fonte di verità per la deduplica
  const installationRequests = useRef(new Map());
  // instSerial richiesti dal render corrente
  const pendingInstallations = useRef(new Set());
  const { mqttStatus } = useContext(MqttContext);
  const emptyInstallationFilter = { title: null, description: null, id: null, filterAlarmed: false };

  let mainContentRef = React.createRef();
  const [installationsCases, setInstallationsCases] = useState({"loaded": false, "cases": {}, "nEntries": 0});
  const [dateTimeInterval, setDateTimeInterval] =
      useState({start: dateToTimestamp(dateSub(new Date(), { days: 1 })), end: dateToTimestamp(new Date())})
  const [devicesInfos, setDevicesInfos] = useState(new Map());
  const [limit, setLimit] = useState(10);
  const [caseType, setCaseType] = useState(null);
  const [installationsFilterInfo, setInstallationsFilterInfo] = useState(emptyInstallationFilter);
  const [cannotChangeParams, setCannotChangeParams] = useState(false)
  const [asyncsInProgress, setAsyncsInProgress] = useState(0)
  const asyncsCounter = useRef(0);

  const delayedUpdateDateTime = useDebounceCallback(2000);

  function renderLoadingSpinner() {
    return (
        <div
            className="embedded-loading-overlay-page"
            id="embedded-loading-overlay-page"
            style={cannotChangeParams ? null : {display: 'none'}}
        >
          <Puff
              color="#00BFFF"
              height={100}
              // visible={cannotChangeParams === true}
              visible={true}
              width={100}
              wrapperClass="loading-spinner"
              // timeout={3000} //3 secs
          />
        </div>
    );
  }

  async function exportCSV(cases, caseType) {
    if (!cases || !cases.loaded) {
      alert("No data to export");
      return;
    }

    document.getElementById("export-button").style.backgroundColor = "var(--default-disabled-button-bg-color)";
    const oldText = document.getElementById("export-button").textContent;
    document.getElementById("export-button").textContent = oldText + "...";
    setCannotChangeParams(true);
    try {
      const startD = timestampToDate(dateTimeInterval.start);
      const endD = timestampToDate(dateTimeInterval.start);
      const startStr = `${startD.getYear() + 1900}${(startD.getMonth() + 1).toString().padStart(2, '0')}${(startD.getDate()).toString().padStart(2, '0')}T` +
          `${(startD.getHours()).toString().padStart(2, '0')}${(startD.getMinutes()).toString().padStart(2, '0')}`;
      const endStr = `${endD.getYear() + 1900}${(endD.getMonth() + 1).toString().padStart(2, '0')}${(endD.getDate()).toString().padStart(2, '0')}T` +
          `${(endD.getHours()).toString().padStart(2, '0')}${(endD.getMinutes()).toString().padStart(2, '0')}`;
      const filename = "reviews_" + startStr + "-" + endStr + ".csv";
      let content = "";
      if(caseType === CASE_DESCRIPTION_TYPE_PROG_CALL) {
        content = `${t('installationsReviews.csvHeaders.instSerial')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.instName')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.instDesc')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.caseTitle')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.date')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.time')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.entryDesc')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.callReply')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.authFirst')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.authLast')}\n`;
      } else {
        content = `${t('installationsReviews.csvHeaders.instSerial')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.instName')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.instDesc')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.caseId')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.caseType')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.caseTitle')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.caseDesc')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.date')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.time')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.entryType')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.entryDesc')}${t('csvSeparator')}` +
            `${t('installationsReviews.csvHeaders.authFirst')}${t('csvSeparator')}${t('installationsReviews.csvHeaders.authLast')}\n`;
      }

      let instArray = [];
      for(const installationSerial in installationsCases.cases) {
        if(installationsFilterInfo != null) {
          let skip = false;
          for (const key of ["title", "description", "id"]) {
            if (installationsFilterInfo[key] && installationsFilterInfo[key].trim() !== "") {
              const inst = installations[installationSerial];
              // Partial match, case-insensitive for usability
              if (
                  !(
                      inst[key] &&
                      inst[key].toLowerCase().includes(installationsFilterInfo[key].toLowerCase())
                  )
              ) {
                skip = true;
              }
            }
          }
          if(skip)
            continue;
        }

        instArray.push(installationSerial);
      }


      for(const installationSerial of instArray)
      {
        const inst = installations[installationSerial];
        const prefix = installationSerial + t('csvSeparator') + inst.title + t('csvSeparator') + inst.description + t('csvSeparator');
        content = renderCSVInstallationsTableRows(caseType, content, prefix, installationSerial, installationsCases.cases[installationSerial])
      }

      const blob = new Blob([content], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (e) {
      alert("Error exporting CSV");
    }
    document.getElementById("export-button").textContent = oldText;
    document.getElementById("export-button").style.backgroundColor = "var(--default-button-bg-color)";
    setCannotChangeParams(false);
  }

  function getInstallationDevices(instSerial) {
    if (devicesInfos.has(instSerial))
      return devicesInfos.get(instSerial);

    // Già richiesta (in volo o completata): non accodare di nuovo
    if (!installationRequests.current.has(instSerial))
      pendingInstallations.current.add(instSerial);

    return null;
  }

  function reloadInstallationsCases() {
    loadInstallationsCases(dateTimeInterval?.start, dateTimeInterval?.end, limit, caseType)
        .then((newEntries) => {
          if(newEntries != null) {
            let nEntr = 0;
            for(const installation in newEntries) {
              for(let cases = 0; cases < newEntries[installation].length; cases++) {
                for(let caseEntries = 0; caseEntries < newEntries[installation][cases].instCaseEntries.length; caseEntries++) {
                  nEntr++;
                }
              }
            }
            setInstallationsCases({"loaded": true, "cases": newEntries, "nEntries": nEntr})
          }
        })
  }

  function caseTypeToLabel(caseType) {
    switch(caseType) {
      case null:
        return `${t('installationsReviews.caseAll')}`;
      case 1:
        return `${t('installationsReviews.caseTypeAlarm')}`;
      case 2:
        return `${t('installationsReviews.caseTypeWarning')}`;
      case 3:
        return `${t('installationsReviews.caseTypeTech')}`;
      case 4:
        return `${t('installationsReviews.caseTypeCall')}`;
      case 5:
        return `${t('installationsReviews.caseTypeJournal')}`;
      case 6:
        return `${t('installationsReviews.caseTypeProgCall')}`;
      default:
        return `${caseType}`;
    }
  }

  // function getDeviceInfo(instSerial, deviceId)
  // {
  //   const key = instSerial + "#" + deviceId;
  //   if(devicesInfos.has(key))
  //     return devicesInfos.get(key)
  //
  //   devicesInfos.set(key, null);
  //
  //   requestDeviceUpdate(instSerial, deviceId)
  //   .then((info) => {
  //     devicesInfos.set(key, info);
  //     setDevicesInfos(new Map(devicesInfos));
  //   })
  //   return null;
  // }

  function renderInstallationsTableRows(instSerial, installationCases) {
    if(installationCases == null)
      return;

    // Accoda la richiesta solo se almeno un case ha bisogno delle info dispositivo
    const needsDevices = installationCases.some(
        caseInfo => caseInfo?.deviceId != null || caseInfo?.caseData?.dynamicPosition != null);
    const instDevices = needsDevices ? getInstallationDevices(instSerial) : null;

    return installationCases.map((caseInfo) => {
      const deviceInfo = caseInfo?.deviceId ? (instDevices?.get(caseInfo.deviceId) ?? null) : null;
      return (
          <CaseTableRow
              key={instSerial + caseInfo?.id.toString()}
              caseInfo={caseInfo}
              deviceInfo={deviceInfo}
              deviceInfos={instDevices}
              inhibitHandler={null}
              installationOffline={false}
              openJournalHandler={null}
              reopenHandler={null}
              takeHandler={null}
          />
      );
    });
  }

  function renderCSVInstallationsTableRows(caseType, content, prefix, instSerial, installationCases) {
    if(installationCases == null)
      return content;

    for (const caseId in installationCases) {
      const caseInfo = installationCases[caseId];

      for(const entryId in caseInfo?.instCaseEntries) {
        const entry = caseInfo?.instCaseEntries[entryId];

        if(caseType === CASE_DESCRIPTION_TYPE_PROG_CALL) {
          content += prefix + caseInfo.title + t('csvSeparator') + timestampToLocalDateString(entry.dateTimeUtc) + t('csvSeparator') +
              timestampToLocalTimeString(entry.dateTimeUtc) + t('csvSeparator') + entry.description + t('csvSeparator') + ((caseInfo?.caseData?.result === "has-replied") ? 1 : (caseInfo?.caseData?.result === "has-not-replied") ? 0 : caseInfo?.caseData?.result ?? 0) +
              t('csvSeparator') + entry.userFirstName + t('csvSeparator') + entry.userLastName + '\n';
        } else {
          content += prefix + caseInfo.id + t('csvSeparator') + caseInfo.type + t('csvSeparator') + caseInfo.title + t('csvSeparator') + caseInfo.description + t('csvSeparator') + timestampToLocalDateString(entry.dateTimeUtc) + t('csvSeparator') +
              timestampToLocalTimeString(entry.dateTimeUtc) + t('csvSeparator') + entry.entryType + t('csvSeparator') + entry.description + t('csvSeparator') + entry.userFirstName +
              t('csvSeparator') + entry.userLastName + '\n';
        }
      }
    }
    return content;
  }

  function renderInstallations(installationsCases, installationsFilterInfo) {
    if(installationsCases?.nEntries > MAX_ENTRIES) {
      return <p>{t('installationsReviews.tooManyEntries')}</p>;
    }

    if(installationsCases?.cases == null || installationsCases?.cases?.length === 0)
      return <p>{`${t('installationsReviews.noCasesMessage')}`}</p>;

    let instArray = [];
    for(const installationSerial in installationsCases.cases) {
      if(installationsFilterInfo != null) {
        let skip = false;
        for (const key of ["title", "description", "id"]) {
          if (installationsFilterInfo[key] && installationsFilterInfo[key].trim() !== "") {
            const inst = installations[installationSerial];
            // Partial match, case-insensitive for usability
            if (
                !(
                    inst[key] &&
                    inst[key].toLowerCase().includes(installationsFilterInfo[key].toLowerCase())
                )
            ) {
              skip = true;
            }
          }
        }
        if(skip)
          continue;
      }

      instArray.push(
          <div
              key={installationSerial}
          >
            <h1
                className="review-inst-header"
                title={installationSerial}
            >
              <span
                  onClick={() => {
                    handleSelectInstallation(installationSerial);
                    history.push(SITE_LINKS.STATUS);
                  }}
                  style={{cursor: 'pointer'}}
              >{`${installations[installationSerial].title}`}</span>
            </h1>
            <h4 className={"review-inst-sub-header"}>
              {`${installations[installationSerial].description}`}
            </h4>
            <hr />
            <div
              className="content-wrap"
            >
              <div className="content-panel">
                {renderInstallationsTableRows(installationSerial, installationsCases.cases[installationSerial])}
              </div>
            </div>
          </div>
      );
    }
    return instArray;
  }

  function startAsync() {
    asyncsCounter.current += 1;
    publishAsyncsCount();
  }

  function endAsync() {
    asyncsCounter.current = Math.max(0, asyncsCounter.current - 1);
    publishAsyncsCount();
  }

  // Pubblica il contatore nello stato SEMPRE fuori dalla fase di render
  function publishAsyncsCount() {
    Promise.resolve().then(() => {
      setAsyncsInProgress(asyncsCounter.current);
    });
  }

  useEffect(() => {
    if (pendingInstallations.current.size === 0)
      return;

    const toLoad = [...pendingInstallations.current];
    pendingInstallations.current.clear();

    toLoad.forEach((instSerial) => {
      // Doppia guardia: copre i render concorrenti / StrictMode
      if (installationRequests.current.has(instSerial))
        return;

      startAsync();

      // returnHidden=true: evita che loadAllInstallationData sovrascriva
      // devicesState e instDevicesUpdateMapping dell'installazione selezionata
      const request = loadAllInstallationData(instSerial, true, true, true)
          .then((devices) => {
            // loadAllInstallationData assorbe gli errori e ritorna undefined
            const instDevices = (devices instanceof Map) ? devices : new Map();
            installationRequests.current.set(instSerial, instDevices);
            setDevicesInfos((cur) => {
              const next = new Map(cur);
              next.set(instSerial, instDevices);
              return next;
            });
            return instDevices;
          })
          .catch((error) => {
            console.error("loadAllInstallationData failed for " + instSerial, error);
            // Cache negativa: senza di essa il render successivo riaccoda la stessa chiamata all'infinito
            installationRequests.current.set(instSerial, new Map());
            setDevicesInfos((cur) => {
              const next = new Map(cur);
              next.set(instSerial, new Map());
              return next;
            });
            return new Map();
          })
          .finally(() => endAsync());

      // Registrazione SINCRONA e immediata: da qui in poi l'installazione è "presa"
      installationRequests.current.set(instSerial, request);
    });
  });
  
  useEffect(() => {
    if(userType == null) {
      return;
    }
    if(userType !== "remote_assistance" && userType !== "service_center" && userType !== "service_center_coordinator" && userType !== "service_center_operator") {
      setInstallationsCases({"loaded": false, "cases": [], "nEntries": 0})
      alert(`${t('forbiddenPageAccess')}`)
      history.push(SITE_LINKS.INSTALLATIONS);
    }

    if(installations == null) {
      setInstallationsCases({"loaded": false, "cases": [], "nEntries": 0})
      return
    }

    startAsync();
    loadInstallationsCases(dateTimeInterval.start, dateTimeInterval.end, limit, caseType)
        .then((newEntries) => {
          let nEntr = 0;
          for(const installation in newEntries) {
            for(let cases = 0; cases < newEntries[installation].length; cases++) {
              for(let caseEntries = 0; caseEntries < newEntries[installation][cases].instCaseEntries.length; caseEntries++) {
                nEntr++;
              }
            }
          }
          if(newEntries != null) {
            setInstallationsCases({"loaded": true, "cases": newEntries, "nEntries": nEntr})
          }
        })
        .catch((error) => {
          console.error("Error loading installations cases:", error);
        })
        .finally( () => { endAsync() });
  }, [installations, dateTimeInterval, limit, caseType, userType]);

  useEffect(() => {
    setCannotChangeParams(asyncsInProgress > 0);
  }, [asyncsInProgress]);

  if(userType == null) {
    return <div>{`${t('loadingMessage')}`}</div>;
  }
  if(userType !== "remote_assistance" && userType !== "service_center" && userType !== "service_center_coordinator" && userType !== "service_center_operator" ) {
    alert(`${t('forbiddenPageAccess')}`)
    history.push(SITE_LINKS.INSTALLATIONS);
    return null;
  }

  return (
      <>
        <HeaderSection
            currRoute={currRoute}
            errors={errors}
            mainContentRef={mainContentRef}
            mqttStatus={mqttStatus}
            selectedInst={selectedInst}
        />
        <section className="main-content" ref={mainContentRef}>
          {renderLoadingSpinner()}
          <PermanentAlertsBar />
          <div className="main-inner-div">
            <h1 className="alerts-header">
              {`${t('installationsReviews.title')}`}
            </h1>
            <hr/>
            <div className="interval-selection reviews">
              <div className="interval-selection">
                <label style={{width: '50%', marginRight: '10px'}}>
                  <p style={{marginBottom: 0, marginTop: 0}}><b>{t('installationsReviews.filterFrom')}:</b></p>
                  <DatePicker
                      dateFormat="Pp"
                      endDate={timestampToDate(dateTimeInterval.end)}
                      locale={i18n.language}
                      maxDate={new Date()}
                      onChange={(date) => {
                        delayedUpdateDateTime( () => {
                          setDateTimeInterval((cur) => {
                            cur.start = dateToTimestamp(date);
                            if(cur.start >= cur.end) {
                              cur.start = cur.end - 86400;
                            }
                            return {...cur};
                          })
                        })
                      }}

                      popperPlacement="right"
                      selected={timestampToDate(dateTimeInterval.start)}
                      showDisabledMonthNavigation
                      showMonthDropdown
                      showTimeSelect
                      showYearDropdown
                      startDate={timestampToDate(dateTimeInterval.start)}
                      timeCaption={`${t("Time")}`}
                      timeIntervals={60}
                      wrapperClassName="start-filter-date-time"
                  />
                </label>
              </div>
              <div className="interval-selection">
                <label style={{width: '50%', marginRight: '10px'}}>
                  <p style={{marginBottom: 0, marginTop: 0}}><b>{t('installationsReviews.filterTo')}:</b></p>
                  <DatePicker
                      dateFormat="Pp"
                      endDate={timestampToDate(dateTimeInterval.end)}
                      locale={i18n.language}
                      maxDate={new Date()}
                      minDate={timestampToDate(dateTimeInterval.start)}
                      onChange={(date) => {
                        delayedUpdateDateTime( () => {
                          setDateTimeInterval((cur) => {
                            cur.end = dateToTimestamp(date);
                            if(cur.end <= cur.start) {
                              cur.end = cur.start + 86400;
                            }
                            return {...cur};
                          })
                        })
                      }}
                      popperPlacement="left"
                      selected={timestampToDate(dateTimeInterval.end)}
                      showDisabledMonthNavigation
                      showMonthDropdown
                      showTimeSelect
                      showYearDropdown
                      startDate={timestampToDate(dateTimeInterval.start)}
                      timeCaption={`${t("Time")}`}
                      timeIntervals={60}
                      wrapperClassName="end-filter-date-time"
                  />
                </label>
              </div>
              <div className="interval-selection dd">
                <label htmlFor={"journal-limit"}>
                  <b>{`${t('installationsReviews.limit')}:`}</b>
                  <Select
                      className="dropdown-select"
                      classNamePrefix="select"
                      isDisabled={false}
                      isSearchable={false}
                      name="journal-limit"
                      onChange={(selection) => {
                        setLimit(selection.value)
                      }}
                      options={[
                        {value: 5, label: '5'},
                        {value: 10, label: '10'},
                        {value: 15, label: '15'},
                        {value: 20, label: '20'},
                        {value: 50, label: '50'},
                        {value: 100, label: '100'},
                        {value: -1, label: `${t('All')}`},
                      ]}
                      value={{value: limit, label: `${limit === -1 ? t('All') : limit}`}}
                  />
                </label>
              </div>
              <div className="interval-selection dd end">
                <label htmlFor={"journal-caseType"}>
                  <b>{`${t('installationsReviews.caseType')}:`}</b>
                  <Select
                      className='dropdown-select case-type'
                      classNamePrefix='select'
                      isDisabled={false}
                      isSearchable={false}
                      name="journal-caseType"
                      onChange={(selection) => {
                        setCaseType(selection.value)
                      }}
                      options={[
                        {value: null, label: caseTypeToLabel(null)},
                        {value: 1, label: caseTypeToLabel(CASE_DESCRIPTION_TYPE_ALARM)},
                        {value: 2, label: caseTypeToLabel(CASE_DESCRIPTION_TYPE_WARNING)},
                        {value: 3, label: caseTypeToLabel(CASE_DESCRIPTION_TYPE_TECH)},
                        // {value: 4, label: caseTypeToLabel(4)},
                        // {value: 5, label: caseTypeToLabel(5)},
                        {value: 6, label: caseTypeToLabel(CASE_DESCRIPTION_TYPE_PROG_CALL)}
                      ]}
                      value={{value: caseType, label: caseTypeToLabel(caseType)}}
                  />
                </label>
              </div>
            </div>
            <InstallationsFilter displayFilter={true} filter={installationsFilterInfo} hideFilterAlarmed={true} setFilter={setInstallationsFilterInfo}/>
            <button className='cbutton' id={"export-button"} onClick={() => exportCSV(installationsCases, caseType)}>{t('installationsReviews.export')}</button>
            { renderInstallations(installationsCases, installationsFilterInfo) }
          </div>
        </section>
        <FooterSection/>
      </>
  )
});